import { useState, useCallback } from 'react';
import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Alert } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import ActionModal from 'components/actionModal';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useInvoices from '../useInvoices';
import UIHelper from '../../../../../helpers/UIHelper';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = ({ isDelta }) => {
  const {
    data,
    columns,
    filters,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
    onExportTo,
    columnsDelta,
    showModal,
    setShowModal,
  } = useInvoices(true);
  const { t } = useTranslation();

  const toggleExportModal = useCallback((e) => {
    e.stopPropagation();
    setShowModal((s) => !s);
  }, []);

  const clickOk = async () => {
    try {
      await onExportTo();
      setShowModal(false);
    } catch (e) {}
  };

  const exportModal = showModal ? (
    <ActionModal
      loading={loading}
      title={t('Export ot Nego')}
      description={t('Sei sicuro che vuoi esportare dati?')}
      yesBtnText={t('Si')}
      noBtnText={t('No')}
      onClickOk={clickOk}
      onCancel={toggleExportModal}
      type={'info'}
    />
  ) : null;

  const tableData =
    (data.data && data.data[0] && data.data[0].invoices_certificateds) || [];

  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('Fatturato certificato').toUpperCase()}>
        {!isDelta && (
          <Row gutter={16}>
            <Col>
              <Button
                big
                type={'red'}
                iconMargin
                onClick={toggleExportModal}
                loading={loading}
              >
                {t('Export to Nego')}
              </Button>
            </Col>
            <Col>
              <Button
                big
                type={'green'}
                iconMargin
                icon={<ExcelIcon fill={'#fff'} />}
                onClick={handleDownloadExcel}
              >
                {t('Export')}
              </Button>
            </Col>
            {pages?.ability?.can_create && (
              <Col>
                <Link to={'new'}>
                  <Button width={'138px'} big icon={<PlusOutlined />}>
                    {t('NUOVO')}
                  </Button>
                </Link>
              </Col>
            )}
            {pages?.ability?.can_create && (
              <Col>
                <Link to={'newFile'}>
                  <Button width={'138px'} big icon={<PlusOutlined />}>
                    {t('Carica file')}
                  </Button>
                </Link>
              </Col>
            )}
          </Row>
        )}
      </PageHeader>
      <div className={styles.container}>
        <br />
        {!isDelta && (
          <>
            <Filters filters={filters} />
            <Divider />
          </>
        )}
        <Table
          columns={UIHelper.assignTire(isDelta ? columnsDelta : columns)}
          dataSource={tableData}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: isDelta ? 2000 : 1000 }}
        />
      </div>
      {exportModal}
      <Routes>
        <Route path={':id/delete'} element={<DeleteModal />} />
      </Routes>
    </>
  );
};

export default MainPage;
